import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autogrow"
export default class extends Controller {
  static values = { height: Number }

  connect() {
    this.element.style.overflow = 'hidden';
    this.grow();
  }

  grow() {
    //this.element.style.height = `${this.heightValue}px`;
    //console.log(this.element)
    this.element.style.height = `${this.heightValue}px`;
    this.element.style.height = `${this.element.scrollHeight}px`;
  }
}
